import React, { FC } from 'react'
import { Box, Typography } from 'transfix-ui/core'
import { IMotorCarrier } from 'apps/fleet-planner/types'
import { ContextCard } from 'transfix-ui'

interface IAdminEmailContextCardProps {
  maskedAdminEmails: IMotorCarrier['maskedAdminEmails']
}

/**
 * Context card for displaying masked admin email addresses
 */
export const AdminEmailContextCard: FC<IAdminEmailContextCardProps> = ({
  maskedAdminEmails = [],
}) => {
  return (
    <ContextCard triggerText='Who are the admins?'>
      <Box>
        <Typography variant='h3'>Admins</Typography>
        {maskedAdminEmails.map(adminEmail => (
          <Box className='fs-mask' key={adminEmail} pt={0.5}>
            <Typography variant='caption'>{adminEmail}</Typography>
          </Box>
        ))}
      </Box>
    </ContextCard>
  )
}
